<template>
  <div class="hello">
    <el-skeleton :loading="!loading" animated>
      <template slot="template">
        <div class="hello-top">
          <el-skeleton-item variant="image" class="hello-top-img" />
          <div style="padding: 14px">
            <el-skeleton-item variant="h3" style="width: 142px" />
            <div style="margin-top: 6px; height: 16px">
              <el-skeleton-item
                variant="text"
                style="margin-right: 16px; width: 175px"
              />
            </div>
            <div style="margin-top: 28px; display: flex">
              <el-skeleton-item
                variant="button"
                id="downloadButton"
                class="hello-top-button"
              />
              <el-skeleton-item
                style="margin-left: 10px"
                variant="button"
                id="downloadButton"
                class="hello-top-button"
              />
            </div>
          </div>
        </div>
        <div class="hello-conter">
          <div class="hello-conter-div">
            <el-skeleton-item class="hello-conter-div-4" variant="text" />
            <el-skeleton-item class="hello-conter-div-5" variant="text" />
            <el-skeleton-item class="hello-conter-div-6" variant="text" />
          </div>
          <div class="hello-conter-div">
            <el-skeleton-item class="hello-conter-div-4" variant="text" />
            <el-skeleton-item class="hello-conter-div-5" variant="text" />
            <el-skeleton-item class="hello-conter-div-6" variant="text" />
          </div>
          <div class="hello-conter-div">
            <el-skeleton-item class="hello-conter-div-4" variant="text" />
            <el-skeleton-item class="hello-conter-div-5" variant="text" />
            <el-skeleton-item class="hello-conter-div-6" variant="text" />
          </div>
          <div class="hello-conter-div">
            <el-skeleton-item class="hello-conter-div-4" variant="text" />
            <el-skeleton-item class="hello-conter-div-5" variant="text" />
            <el-skeleton-item class="hello-conter-div-6" variant="text" />
          </div>
        </div>
        <div class="hello-introduce" style="margin-top: 20px">
          <el-skeleton-item
            class="hello-introduce-title"
            style="width: 114px"
            variant="text"
          ></el-skeleton-item>
          <el-skeleton-item
            class="hello-introduce-test"
            style="margin-top: 20px"
            variant="text"
          ></el-skeleton-item>
          <el-skeleton-item
            class="hello-introduce-test"
            variant="text"
          ></el-skeleton-item>
          <el-skeleton-item
            class="hello-introduce-test"
            variant="text"
          ></el-skeleton-item>
        </div>
        <div class="hello-lunbo" style="margin-top: 20px">
          <el-skeleton-item
            class="hello-introduce-title"
            style="width: 114px"
            variant="text"
          ></el-skeleton-item>
          <div style="display: flex">
            <el-skeleton-item
              variant="image"
              style="width: 250px; height: 416px; margin-top: 20px"
            />
            <el-skeleton-item
              variant="image"
              style="
                width: 220px;
                height: 416px;
                margin-top: 20px;
                margin-left: 20px;
              "
            />
          </div>
        </div>
      </template>
      <template>
        <div class="hello-top" style="display: flex">
          <img class="hello-top-img" src="../assets/logo.png" alt="" />
          <div class="marginleft20">
            <div>
              <div class="hello-top-title" style="font-weight: bold">
                Macro-巨汇
              </div>
              <div class="hello-top-test">参考资料</div>
            </div>
            <div class="items-end" style="margin-top: 28px">
              <button class="hello-top-button" id="downloadButton" v-if="isIOS">
                App Store
              </button>
              <button
                v-if="isAndroid"
                style="margin-left: 10px"
                class="hello-top-button"
                @click="downloadFile"
              >
                Android
              </button>
              <template v-if="!isIOS && !isAndroid">
                <button class="hello-top-button" id="downloadButton">
                  App Store
                </button>
                <button
                  style="margin-left: 10px"
                  class="hello-top-button"
                  @click="downloadFile"
                >
                  Android
                </button>
              </template>
            </div>
          </div>
        </div>
        <div class="hello-conter">
          <div class="hello-conter-div">
            <div class="hello-conter-div-1">7.6M ratings</div>
            <div class="hello-conter-div-2">5.0</div>
            <div class="hello-conter-div-3">
              <img
                class="hello-conter-div-3-img"
                src="../assets/Star-2.png"
                alt=""
              />
              <img
                class="hello-conter-div-3-img"
                src="../assets/Star-2.png"
                alt=""
              />
              <img
                class="hello-conter-div-3-img"
                src="../assets/Star-2.png"
                alt=""
              />
              <img
                class="hello-conter-div-3-img"
                src="../assets/Star-2.png"
                alt=""
              />
              <img
                class="hello-conter-div-3-img"
                src="../assets/Star-2.png"
                alt=""
              />
            </div>
          </div>
          <div class="hello-conter-shu"></div>
          <div class="hello-conter-div">
            <div class="hello-conter-div-1">AGE</div>
            <div class="hello-conter-div-2">17+</div>
            <div class="hello-conter-div-3">Years Old</div>
          </div>
          <div class="hello-conter-shu"></div>
          <div class="hello-conter-div">
            <div class="hello-conter-div-1">RANKING</div>
            <div class="hello-conter-div-2">No.10</div>
            <div class="hello-conter-div-3">socialize</div>
          </div>
          <div class="hello-conter-shu"></div>
          <div class="hello-conter-div">
            <div class="hello-conter-div-1">LANGUAGE</div>
            <div class="hello-conter-div-2">En</div>
            <div class="hello-conter-div-3">+16 more</div>
          </div>
        </div>
        <div class="hello-introduce">
          <div class="hello-introduce-title" style="font-weight: bold">
            New Features
          </div>
          <div
            class="hello-introduce-title"
            style="
              font-weight: 400;
              font-size: 12px;
              color: #8e8e93;
              line-height: 14px;
            "
          >
            <div>VERSION 1.5.6</div>
          </div>
          <div
            class="hello-introduce-test"
            style="font-weight: 600; letter-spacing: 0.5px"
          >
            <p>1.Interface communication.</p>
            <p>2.Accelerate API data requests.</p>
          </div>
        </div>
        <div class="hello-lunbo">
          <div class="hello-introduce-title" style="font-weight: bold">
            Preview
          </div>
          <div style="display: flex; overflow: hidden; overflow-x: scroll">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="hello-lunbo-div"
              :style="index != '3' ? 'margin-right: 20px;' : ''"
            >
              <img
                style="width: 220px; height: 416px; border-radius: 20px"
                :src="item.img"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
    </el-skeleton>
    <el-dialog title="Downloading" :visible.sync="isDownloading" top="40vh">
      <el-progress :percentage="downloadProgress" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {},
  data() {
    return {
      datainde: 0,
      dataList: [
        { img: require("@/assets/1.png") },
        { img: require("@/assets/2.png") },
        { img: require("@/assets/3.png") },
        { img: require("@/assets/4.png") },
        // { img: require("@/assets/5.png") },
        // { img: require("@/assets/6.png") },
        // { img: require("@/assets/7.png") },
      ],
      loading: false,
      isAndroid: "",
      isIOS: "",
      downloadProgress: 0,
      progressStatus: "",
      isDownloading: false,
      cando: true,
    };
  },
  mounted: function () {
    const userAgent = navigator.userAgent;
    this.isAndroid = /Android/i.test(userAgent);
    this.isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    if (this.isIOS || (!this.isAndroid && !this.isIOS)) {
      axios
        .get(window.global.baseUrl + "/install")
        .then((response) => {
          // 请求成功后的回调函数
          console.log(response);
          // setTimeout(() => {
          //   this.loading = true
          // }, 2000);
          this.loading = true;
          const s = document.createElement("script");
          s.type = "text/javascript";
          s.src = "//web.cdn.openinstall.io/openinstall.js";
          s.addEventListener(
            "load",
            () => {
              var data = {
                channel: response.data.channel,
                channelCode: window.global.channelCode,
              };
              new OpenInstall(
                {
                  appKey: "pjzmnv", //appkey参数配置,需要自行替换对应的appkey
                  onready: function () {
                    var m = this,
                      button = document.getElementById("downloadButton");
                    m.schemeWakeup();
                    button.onclick = function () {
                      m.wakeupOrInstall();
                      return false;
                    };
                  },
                },
                data
              );
            },
            false
          );
          document.head.appendChild(s);
        })
        .catch((error) => {
          // 请求失败后的回调函数
          console.log(error);
        });
    } else {
      this.loading = true;
    }
  },
  methods: {
    change(e) {
      this.datainde = e;
    },
    getAndroid() {
      window.location.href = window.global.Android;
    },
    async downloadFile() {
      if (this.cando) {
        const url = window.global.Android; // 替换为真实的 APK 地址
        this.downloadProgress = 0;
        this.isDownloading = true;

        this.progressStatus = "active";
        this.cando = false;
        try {
          const response = await axios.get(url, {
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                this.downloadProgress = Math.floor(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
              }
            },
          });

          const blob = new Blob([response.data], {
            type: "application/vnd.android.package-archive",
          });
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "Macro-巨汇.apk";
          downloadLink.click();
          this.progressStatus = "success";
          this.cando = true;
        } catch (error) {
          this.progressStatus = "exception";
          this.$message.error("Download error!");
          console.error(error);
          this.cando = true;
        } finally {
          this.isDownloading = false;
          this.cando = true;
        }
      } else {
        this.$message.error("Your download is in progress, please wait!");
      }
    },

    updateProgress(event) {
      if (event.lengthComputable) {
        this.downloadProgress = Math.round((event.loaded * 100) / event.total);
      }
    },
  },
};
</script>

<style scoped>
.download-container {
  padding: 20px;
}
.scroll {
  overflow: scroll;
}

.scroll::-webkit-scrollbar {
  display: none;
}

.hello {
  padding: 20px;
  background-color: white;
  /* position: fixed; */
  /* overflow-x: auto; */
  /* width: calc(100% - 40px); */
}

.marginleft20 {
  margin-left: 20px;
}

.hello-top {
  display: flex;
}

.hello-top-title {
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0px;
}

.hello-top-test {
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0px;
  color: #999999;
}

.hello-conter {
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  display: flex;
  align-items: center;
  overflow-x: auto;
  /* max-width: 375px; */
  margin-top: 20px;
}

.hello-conter-div {
  width: 25%;
  margin: 10px 0;
  text-align: center;
}

.hello-conter-shu {
  width: 1px;
  background: #dddddd;
  height: 38px;
}

.hello-conter-div-1 {
  font-size: 10px;
  line-height: 140%;
  letter-spacing: 0px;
  text-transform: uppercase;
  color: #8e8e93;
}

.hello-conter-div-2 {
  font-size: 20px;
  line-height: 36px;
  letter-spacing: 0px;
  text-transform: uppercase;
  color: #8e8e93;
}

.hello-conter-div-4 {
  width: 70px;
}

.hello-conter-div-5 {
  width: 30px;
}

.hello-conter-div-6 {
  width: 70px;
}

.hello-conter-div-3 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-size: 12px;
  color: #8e8e93;
}

.hello-conter-div-3-img {
  width: 14px;
  height: 14px;
}

.hello-introduce-title {
  font-size: 20px;
  line-height: 50px;
  letter-spacing: 0px;
  text-transform: capitalize;
  color: #000000;
}

.hello-introduce-test {
  font-size: 13px;
  color: #000000;
}

.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}

.items-end {
  display: flex;
  align-items: flex-end;
}

.hello-top-button {
  /* min-width: 86px; */
  padding: 0 20px;
  height: 32px;
  border-radius: 16px;
  background: #0d768b;
  border: 0px;
  font-size: 14px;
  color: white;
}

.hello-top-img {
  width: 114px;
  height: 114px;
}
.hello-lunbo-div {
  border: 1px solid #8e8e93;
  border-radius: 20px;
}
</style>
